/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';
/**
 * 客户端日志.
 */
// 判断是否支持console
var log_exist = !!window.console;

// do nothing.
var EMPTY_FUNCTION = function() {
};

// definition 4 empty logger.
var EMPTY_LOGGER = {
    log : EMPTY_FUNCTION,
    warn : EMPTY_FUNCTION,
    trace : EMPTY_FUNCTION,
    debug : EMPTY_FUNCTION,
    info : EMPTY_FUNCTION,
    error : EMPTY_FUNCTION
}

// 日志记录器构造函数
var Logger = function(name) {
    this.name = name;
}
/**
 * 日志记录器方法定义.
 */
Logger.prototype = {
    log : function(msg) {
	log_exist && console.log(this.name + '>>>' + msg);
    },
    warn : function(msg) {
	log_exist && console.warn ? console.warn(this.name + '>>>' + msg) : this.log(msg);
    },
    debug : function(msg) {
	log_exist && console.debug ? console.debug(this.name + '>>>' + msg) : this.log(msg);
    },
    trace : function(msg) {
	log_exist && console.trace ? console.trace(this.name + '>>>' + msg) : this.log(msg);
    },
    info : function(msg) {
	log_exist && console.info ? console.info(this.name + '>>>' + msg) : this.log(msg);
    },
    error : function(msg) {
	log_exist && console.error ? console.error(this.name + '>>>' + msg) : this.log(msg);
    }
}

// 日志记录器池，避免重复构建对象.
var logger_repository = {};

// 可获取日志.
module.exports = {
    /**
     * 获取日志记录器.
     * 
     * @param name
     *                日志记录器名称.
     * @returns Logger.
     */
    getLogger : function(name) {
	if (!log_exist) {
	    return EMPTY_LOGGER;
	}
	if (!logger_repository[name]) {
	    logger_repository[name] = new Logger(name);
	}
	return logger_repository[name];
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/logger/src/com.jufeng.logging.js
// module id = 7
// module chunks = 0 2 19 21 31 32 33 34 36 38 39 44 45 50 52 53 58 59 60 61 62 63 64 69 70 72 73 74 75 83 84 85 86 87 88 89 94 95 96 98 100 101 103 104 105 106 107 109 111 113 114 115 116 117 119 120 121 122 123 124 125 127 128 129 130 131 136 137 140 141 142 143 144 145 146 147 149 150 151 152 153 154 155 157 158 159 160 161 164 166 167 168 169 170 173 175 177 178 179